export const MAX_VISIBLE_AVATARS = 3;
export const GROUP_CARD_VISIBLE_AVATARS = 4;
export const EVENT_TYPES_REQUEST_PARAMS = { isGroupEvent: true } as const;
export const ParticipantMode = {
	GROUP: 'GROUP',
	STUDENT: 'STUDENT'
} as const;

export const ParticipantModeLabel: Record<keyof typeof ParticipantMode, string> = {
	GROUP: 'Grup Seç',
	STUDENT: 'Öğrenci Seç'
};

export const SELECT_PLACEHOLDER = 'Seçiniz';
export const EVENT_GROUPS_SELECTED_SUFFIX = 'grup seçildi';
export const EVENT_GROUPS_SUMMARY_MAX_NAMES = 2;
export const EVENT_GROUPS_EMPTY_TEXT = 'Henüz bir grubunuz yok.';
export const EVENT_GROUPS_EDIT_LOCKED_TEXT = 'Etkinliğin grupları düzenleme sırasında değiştirilemez.';
export const MIXED_GROUPS_DIALOG = {
	TITLE: 'Farklı Gruplardan Öğrenciler Seçtin',
	DESCRIPTION: 'Seçtiğin öğrenciler farklı gruplarda yer alıyor. Bu öğrencileri aynı etkinliğe eklemek istediğine emin misin?',
	CONFIRM_LABEL: 'Seç',
	CANCEL_LABEL: 'Seçime Dön'
};
export const MINUTES_IN_HOUR = 60;

export const DATE_PICKER_FORMAT = 'dd.MM.yyyy';
export const TIME_PICKER_FORMAT = 'HH:mm';
export const TIME_PICKER_INTERVAL_MINUTES = 15;
export const TIME_PICKER_CAPTION = 'Saat';
export const DATE_PICKER_PORTAL_ID = 'cem-datepicker-portal';

export const STUDENT_AVATAR_TONE_COUNT = 8;
export const STUDENT_PICKER_SUBMIT_LABEL = 'Öğrenci Seç';
export const CREATE_EVENT_SUBMIT_LABEL = 'Etkinlik Oluştur';
export const CREATE_EVENT_TITLE = 'Etkinlik Oluştur';
export const EDIT_EVENT_TITLE = 'Etkinliği Düzenle';
export const EDIT_EVENT_SUBMIT_LABEL = 'Kaydet';

export const GROUP_NAME_MAX_LENGTH = 50;
export const GROUP_NAME_PLACEHOLDER = 'Örn. Sınıf 1';
export const CREATE_GROUP_SUBMIT_LABEL = 'Grubu Oluştur';
export const CREATE_GROUP_CANCEL_LABEL = 'Vazgeç';

export const BOUTIQUE_STUDENTS_QUERY_SCOPE = 'boutique';
export const CREATE_GROUP_STUDENTS_LABEL = 'Öğrenciler';
export const CREATE_GROUP_STUDENTS_LOADING_TEXT = 'Öğrenciler yükleniyor...';
export const CREATE_GROUP_STUDENTS_EMPTY_TEXT = 'Gruba eklenebilecek öğrenci bulunamadı.';
export const EXPERT_STUDENTS_FIRST_PAGE = 0;
export const EXPERT_STUDENTS_PAGE_SIZE = 10;
export const EXPERT_STUDENTS_PAGE_SIZE_OPTIONS = [10, 20, 50] as const;
export const PAGE_SIZE_LABEL = 'Sayfa başına';
export const EXPERT_STUDENTS_PICKER_PAGE_SIZE = 100;
export const PAGINATION_FIRST_PAGE = 1;
export const BOUTIQUE_GROUP_TYPE_ID = 1;
export const BOUTIQUE_GROUP_DEFAULT_GRADE_ID = 1;
export const EMPTY_VALUE_LABEL = '-';
export const TABLE_SCROLL_OFFSET = 96;
export const TABLE_SCROLL_DURATION = 400;
export const EXPERT_EVENTS_FIRST_PAGE = 0;
export const EXPERT_EVENTS_PAGE_SIZE = 200;
export const EVENT_DATE_PARAM_FORMAT = 'YYYY-MM-DD';
export const EVENT_TIME_FORMAT = 'HH:mm';
export const EVENT_DAY_END_TIME = '23:59';
export const EVENT_PLATFORM_LABEL: Record<string, string> = {
	ZOOM: 'Zoom',
	GOOGLE_MEET: 'Google Meet',
	YOUTUBE: 'YouTube'
};
export const EXTERNAL_LINK_TARGET = '_blank';
export const HTTP_PREFIX = 'https://';
export const EVENT_NAME_MAX_LENGTH = 100;
export const EVENT_NAME_PLACEHOLDER = 'Örn. AYT Fizik Grup Dersi';
export const EVENT_LINK_PLACEHOLDER = 'https://zoom.us/j/...';
export const EVENT_SHORT_DESCRIPTION_PLACEHOLDER = 'Kısa açıklama';
export const EVENT_SHORT_DESCRIPTION_MAX_LENGTH = 255;
export const EVENT_DEFAULT_COVER_IMAGE_URL = 'https://cdn.dopinghafiza.com/live-expert/boutique/event-cover-default.png';
export const EVENT_PLATFORM_OPTIONS = [
	{ id: 'ZOOM', name: 'Zoom' },
	{ id: 'GOOGLE_MEET', name: 'Google Meet' },
	{ id: 'YOUTUBE', name: 'YouTube' }
] as const;
export const EVENT_TYPE_CODE = {
	GROUP_LIVE_LESSON: 'GROUP_LIVE_LESSON'
} as const;
export const EVENT_TYPE_CARD_META: Record<string, { description: string; iconClass: string }> = {
	[EVENT_TYPE_CODE.GROUP_LIVE_LESSON]: { description: 'Bir gruba ders atayın', iconClass: 'icons-users-group-rounded' },
	STUDY_TOGETHER: { description: 'Tek bir öğrenciye ders atayın', iconClass: 'icons-user' },
	MOTIVATION_TACTIC: { description: 'Randevulu soru çözüm dersi', iconClass: 'icons-microphone' },
	EXAM_HOUR: { description: 'Öğrenci ile birebir görüşme', iconClass: 'icons-chat-round-dots' },
	OTHER: { description: 'Diğer etkinlikler', iconClass: 'icons-menu-dots' }
};
export const EVENT_TYPE_CARD_DEFAULT_META = { description: '', iconClass: 'icons-calendar' };
export const EVENT_PALETTE_SIZE = 30;
export const EVENT_PALETTE_TONE_PREFIX = 'palette';
export const API_ERROR_CODE = {
	STUDENT_NOT_MATCHED: 'LE138',
	MEMBER_ALREADY_ACTIVE: 'LSEM124',
	EXPERT_NOT_IN_ACADEMIC_BOARD: 'EXPERT_NOT_IN_ACADEMIC_BOARD'
} as const;
export const EVENT_ERROR_MESSAGE = {
	STUDENT_NOT_MATCHED: 'Seçilen öğrencilerden biri artık sizinle eşleşmiş değil. Lütfen katılımcı listesini kontrol edin.',
	EXPERT_NOT_IN_ACADEMIC_BOARD: 'Seçilen uzman akademik kurulda yer almıyor.',
	SKIPPED_STUDENTS: 'öğrenci telefon numarası çözülemediği için etkinliğe eklenemedi.',
	JOIN_LINK_MISSING: 'Bu etkinlik için katılım linki tanımlanmamış.',
	REQUIRED_FIELDS: 'Lütfen etkinlik türü, ad, tarih, saat ve platform alanlarını doldurun.',
	PARTICIPANTS_REQUIRED: 'Bir grup ya da en az bir öğrenci seçmelisiniz.',
	FORM_INVALID: 'Lütfen formdaki hatalı alanları düzeltin.'
} as const;
export const EVENT_CREATED_MESSAGE = 'Etkinlik oluşturuldu.';
export const EVENT_UPDATED_MESSAGE = 'Etkinlik güncellendi.';
export const ACADEMIC_BOARD_SERVICE_TYPE = 'PLANNED_LECTURE';

export const EVENT_URL_PROTOCOLS = ['http:', 'https:'] as const;

export const EVENT_VALIDATION_MESSAGE = {
	REQUIRED: 'Bu alan zorunludur.',
	NAME_TOO_SHORT: 'Etkinlik adı en az 3 karakter olmalıdır.',
	INVALID_URL: 'Geçerli bir bağlantı girin. Bağlantı http:// veya https:// ile başlamalıdır.',
	END_BEFORE_START: 'Bitiş saati başlangıç saatinden sonra olmalıdır.',
	START_IN_PAST: 'Başlangıç saati geçmiş bir saat olamaz.',
	GROUP_REQUIRED: 'Lütfen en az bir grup seçin.',
	STUDENTS_REQUIRED: 'En az bir öğrenci seçin.',
	BRANCH_REQUIRED: 'Grup canlı dersi için bir branş seçin.',
	EXPERT_REQUIRED: 'Grup canlı dersi için bir uzman seçin.'
} as const;

export const EVENT_NAME_MIN_LENGTH = 3;
